import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core';
import {provideRouter, Routes, TitleStrategy, withNavigationErrorHandler} from '@angular/router';
import {provideEnvironmentNgxMask} from 'ngx-mask';
import {AngebotComponent} from './angebot/angebot.component';
import {AusschreibungComponent} from './ausschreibung/ausschreibung.component';
import {HomeComponent} from './home/home.component';
import {HttpErrorInterceptor} from './interceptor/http.interceptor';
import {submissionRedirectGuard} from './guard/submission-redirect.guard';
import {KontaktComponent} from './kontakt/kontakt.component';
import {LandingComponent} from './landing/landing.component';
import {AusschreibungResolver} from './resolver/ausschreibung.resolver';
import {AusschreibungService} from './service/ausschreibung.service';
import {PageTitleService} from './service/page-title.service';
import {TenantConfigService} from './service/tenant-config.service';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        canActivate: [submissionRedirectGuard],
        title: () => inject(TenantConfigService).current.content.home.title
    }, {
        path: 'ausschreibung/:id',
        component: AusschreibungComponent,
        canActivate: [submissionRedirectGuard],
        resolve: {ausschreibung: AusschreibungResolver},
        title: 'Ausschreibung'
    }, {
        path: 'angebot/:id',
        component: AngebotComponent,
        canActivate: [submissionRedirectGuard],
        resolve: {ausschreibung: AusschreibungResolver},
        title: 'Ihr Angebot'
    },
    {path: 'landing', component: LandingComponent, canActivate: [submissionRedirectGuard], title: () => inject(TenantConfigService).current.content.landing.title},
    {path: 'ng', redirectTo: 'ausschreibung/undefined'},
    {path: 'index', redirectTo: '', pathMatch: 'full'},
    {path: 'kontakt', component: KontaktComponent, canActivate: [submissionRedirectGuard], title: 'Kontakt'}
];

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withNavigationErrorHandler((error: any) => {
            console.error('Router navigation error' + error);
        })),

        provideHttpClient(withInterceptorsFromDi()),
        provideAppInitializer(() => inject(TenantConfigService).load()),
        provideEnvironmentNgxMask(),
        AusschreibungService,
        {provide: TitleStrategy, useExisting: PageTitleService}, {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        }
    ]
}
